<template>
  <div class="product-image-cell" :style="{ width: size + 'px', height: size + 'px' }">
    <img v-if="url" :src="url" :alt="sku" @click.stop="$emit('zoom', url)" />
    <div v-else-if="notFound" class="product-image-cell__placeholder">
      <md-icon>image</md-icon>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axiosFactory from "../../services/axios.factory";

// Modulweiter Cache: eine Tabelle mit 50 Zeilen laedt jedes Bild nur einmal, auch beim
// Blaettern. null = "kein Bild vorhanden" wird ebenfalls gemerkt (kein 404-Sturm).
const cache = new Map();
// Reaktive Versionsnummer: nach Upload/Loeschen laden montierte Zellen sofort neu,
// statt bis zum naechsten Seitenwechsel den alten Stand zu zeigen
const cacheState = Vue.observable({ version: 0 });

// Nach Upload/Loeschen aufrufen, sonst zeigen die Uebersichten das alte Bild aus dem Cache
export function clearProductImageCache(sku) {
  const url = cache.get(sku);
  if (url) URL.revokeObjectURL(url);
  cache.delete(sku);
  cacheState.version++;
}

export default {
  name: "ProductImage",
  props: {
    sku: { type: String, default: null },
    size: { type: Number, default: 56 },
  },
  data() {
    return { url: null, notFound: false };
  },
  computed: {
    cacheKey() {
      return `${this.sku || ""}|${cacheState.version}`;
    },
  },
  watch: {
    cacheKey: {
      immediate: true,
      handler() {
        const sku = this.sku;
        this.url = null;
        this.notFound = false;
        if (!sku) {
          this.notFound = true;
          return;
        }
        if (cache.has(sku)) {
          this.url = cache.get(sku);
          this.notFound = this.url === null;
          return;
        }
        const requested = sku;
        axiosFactory()
          .get(`/shipping_data/products/image_by_sku/${encodeURIComponent(sku)}/content`, { responseType: "blob" })
          .then((res) => {
            const url = URL.createObjectURL(new Blob([res.data]));
            cache.set(requested, url);
            if (this.sku === requested) this.url = url;
          })
          .catch((err) => {
            // Nur "kein Bild vorhanden" (404) dauerhaft merken - ein einmaliger
            // Netzwerk-/Serverfehler soll das Bild nicht bis zum Reload ausblenden
            if (err && err.response && err.response.status === 404) {
              cache.set(requested, null);
            }
            if (this.sku === requested) this.notFound = true;
          });
      },
    },
  },
};
</script>

<style scoped>
.product-image-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.product-image-cell img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  cursor: zoom-in;
  border-radius: 3px;
}
.product-image-cell__placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f2f2;
  border-radius: 3px;
}
.product-image-cell__placeholder .md-icon {
  color: #c5c5c5;
}
</style>
